/**
 * Home page collage — the shared definition of the `home_collage_order` field.
 * Redmine #262965.
 *
 * ONE DEFINITION, SIX FORMS. The collage is built from Masterlist nodes
 * regardless of type, so Film, Personality, Theme, Institution, Location and
 * Event Masterlist all need this field. Six hand-copied schemas would drift --
 * and the way they would drift is the dangerous way: a form whose `maximum`
 * disagrees with the backend's grid accepts a position the build then refuses,
 * so the admin sees a successful save and the collage silently stops updating.
 *
 * MAX_HOME_COLLAGE_ORDER mirrors the backend's constants/homeCollage.js
 * (desktop 16 x 6). If the grid changes, both move together -- the backend is
 * the authority and rejects anything outside its own range regardless of what
 * this file says, so a mismatch here shows up as a confusing 400, not as a
 * corrupt collage.
 */

export const MAX_HOME_COLLAGE_ORDER = 96;

export const HOME_COLLAGE_ORDER_HELP =
  `Assign a unique position from 1–${MAX_HOME_COLLAGE_ORDER} to include this record in the ` +
  `Home page collage. Leave empty to keep it out. Each position may be used by only one ` +
  `record, and the collage is only rebuilt once every position is filled.`;

/**
 * The JSON Schema fragment. Nullable on purpose: clearing the field is how a
 * record is REMOVED from the collage, so "empty" has to be a valid value rather
 * than a validation error.
 */
export const homeCollageOrderSchema = () => ({
  "type": ["integer", "null"],
  "title": "Home Collage Order",
  "minimum": 1,
  "maximum": MAX_HOME_COLLAGE_ORDER,
  "description": HOME_COLLAGE_ORDER_HELP,
});

/**
 * The uiSchema fragment.
 *
 * ui:emptyValue is null, not "" -- an empty string would reach the backend as a
 * non-integer and be rejected, when what the admin meant was "take this record
 * out of the collage".
 */
export const homeCollageOrderUiSchema = () => ({
  "ui:emptyValue": null,
  "ui:placeholder": `1–${MAX_HOME_COLLAGE_ORDER}, or leave empty`,
});
